// extracted by mini-css-extract-plugin
export default {"detailPanel":"Country_detailPanel__S6eVJ","stickyHeader":"Country_stickyHeader__UjdDw","keyPhrase":"Country_keyPhrase__vDLA-"};